"use strict";
var Observable_1 = require('../../Observable');
var throw_1 = require('../../observable/throw');
Observable_1.Observable.throw = throw_1._throw;
//# sourceMappingURL=throw.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/observable/throw.js